import React from 'react';
import { Link, withPrefix } from 'gatsby';
import slugify from 'slugify';
import _ from 'lodash';

import { TableData, TableRow } from '~components/common/Table';
import { rowRendererProps } from '../propTypes';
import DeadlineRelative from '../../common/DeadlineRelative';

export default function registrationDeadlinesRowRenderer({ state }) {
  const stateName = state.fieldValue;
  const stateSlug = slugify(stateName.toLowerCase());

  const stateData = _.keyBy(state.nodes, 'field_type');

  return (
    <TableRow key={stateSlug}>
      <TableData>
        <a
          href={`/how-to-vote/${stateSlug}/`}
          title={`How to vote in ${stateName}`}
        >
          {stateName}
        </a>
      </TableData>
      <TableData data-title='Registration deadlines'>
        <ul>
          <li>
            <strong>In person: </strong>
            <DeadlineRelative
              relativeDeadline={stateData.registration_deadline_in_person}
            />
          </li>
          <li>
            <strong>By mail: </strong>
            <DeadlineRelative
              relativeDeadline={stateData.registration_deadline_mail}
            />
          </li>
          <li>
            <strong>Online: </strong>
            <DeadlineRelative
              relativeDeadline={stateData.registration_deadline_online}
            />
          </li>
        </ul>
      </TableData>
      <TableData>
        <Link
          to={withPrefix(`/register-to-vote/${stateSlug}/`)}
          title={`Register to vote in ${stateName}`}
        >
          Register to vote in {stateName}
        </Link>
      </TableData>
    </TableRow>
  );
}

registrationDeadlinesRowRenderer.propTypes = rowRendererProps;
